/**
 * Minimal <head> management (title, meta tags, JSON-LD).
 *
 * Replaces react-helmet-async so the tag logic stays in the app bundle:
 * matching tags already present in index.html are updated in place instead of
 * being duplicated, and everything this module wrote is undone on cleanup.
 */
const MANAGED = 'data-bmk-head';

function upsertMeta(attr, key, content, journal) {
  if (content == null || content === '') return;
  const el = document.head.querySelector(`meta[${attr}="${key}"]`);
  const prev = el ? el.getAttribute('content') : null;
  const target = el || document.createElement('meta');

  if (!el) {
    target.setAttribute(attr, key);
    target.setAttribute(MANAGED, '');
    document.head.appendChild(target);
  }
  target.setAttribute('content', String(content));
  journal.push({ el: target, prev });
}

/**
 * Applies a head spec and returns a cleanup function.
 * spec: { title?: string, meta?: [attr, key, content][], jsonLd?: object }
 */
export function applyHead({ title, meta = [], jsonLd } = {}) {
  const journal = [];
  const prevTitle = document.title;

  if (title) document.title = title;
  meta.forEach(([attr, key, content]) => upsertMeta(attr, key, content, journal));

  let script = null;
  if (jsonLd) {
    script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute(MANAGED, '');
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);
  }

  return () => {
    if (title) document.title = prevTitle;
    journal.forEach(({ el, prev }) => {
      if (prev === null) el.remove();
      else el.setAttribute('content', prev);
    });
    if (script) script.remove();
  };
}